export default () => ({
  componentName: 'cell-bonuses',
});
